/// <reference path="../../global/fn.js" />


;(function ($) {

    $.widget("nsp.productPromo", {
        opts: {
        },

        _create: function () {
            this.wrap = this.element;

            this.wrap.appear(_=> {
                
                this.wrap.addClass('is-onscreen')
                

            }, { accX: 0, accY: -200 })
            
            
        }


    });
})(jQuery);